module.exports = __webpack_public_path__ + "static/media/spot.f1435e94.jpg";